/// <reference path="../../../scripts/typings/pdfjs/pdfjs.external.d.ts" />

import uiCore = require("../core/uicore");
import PDFJS = require("pdfjs-dist");

export class PdfReportViewerDirective implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardComponentDescription = {
        DirectiveId: "crewpdfviewer",
        Template: require("./crewpdfviewer.html"),
        AngularDependencies: [uiCore.ScopeDependency, uiCore.HTTPDependency],
        Bindings: {
            scale: "=",
            reporturl: "=",
        }
    }

    _canvas: HTMLElement;

    constructor(...args: any[]) {
        this._locator = uiCore.DependencyLocator.Create(PdfReportViewerDirective, args);
        this._locator.getScopeDependency().$watch("vm.reporturl", (_newvalue, _oldvalue) => {
            this.fetchpdf();
        });
    }

    public pdf: any;
    public reporturl: string;
    public scale: number = 1.5;
    public pageindices: number[] = [];
    public pageindex: number = 1;

    private _locator: uiCore.DependencyLocator;
    private _isLoading = false;

    private fetchpdf() {
        if (this._isLoading) return;
        var url = this.reporturl;
        this.pdf = null;
        this.pageindices = [];
        if (!url || url == "") {
            return;
        }

        this._isLoading = true;

        this._locator.getHTTPDependency().get(url, { responseType: 'arraybuffer' }).then(response => {
            this.processpdf(new Uint8Array(<ArrayBuffer>response.data));
        }).catch(_reason => {
            // Handle error
        }).finally(() => {
            this._isLoading = false;
        });

    }

    private processpdf = (pdfbytes) => {

        PDFJS.getDocument(pdfbytes)
            .then(pdf => {
                var numPages: number = pdf.numPages;
                this.pdf = pdf;
                var pageindices: number[] = [];
                for (var i = 0; i < numPages; i++) {
                    pageindices.push(i + 1);
                }

                this.pageindices = pageindices;
            });
    }
} 


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/crewpdfviewer.ts